import { render } from "./SortedCheckboxTable.vue?vue&type=template&id=1c4f05bc"
import script from "./SortedCheckboxTable.vue?vue&type=script&lang=js"
export * from "./SortedCheckboxTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__